import { IconDice5 } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const RoundsPage = lazy(() => import("./RoundsPage").then((m) => ({ default: m.RoundsPage })));
const page = (surface: "admin" | "portal") =>
  createElement(Suspense, { fallback: null }, createElement(RoundsPage, { surface }));

export const routes: FeatureRoute[] = [
  { path: "/admin/rounds", roles: CAPS.admin.rounds, element: page("admin") },
  { path: "/portal/rounds", roles: CAPS.portal.rounds, element: page("portal") },
];

export const nav: NavItem[] = [
  { label: "Rounds", path: "/admin/rounds", icon: IconDice5, surface: "admin", roles: CAPS.admin.rounds },
  { label: "Rounds", path: "/portal/rounds", icon: IconDice5, surface: "portal", roles: CAPS.portal.rounds },
];
